import styled from 'styled-components'
import theme from 'styles/theme'

export const ProductGridWrapper = styled.div`
  margin: 0 40px ${theme.space[11]};
  position: relative;

  ${theme.mediaQueries.large} {
    margin: 0 auto 100px;
  }
`

export const ProductGridContainer = styled.section`
  ${theme.mediaQueries.medium} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 -${theme.space[1]};
  }

  article {
    margin-bottom: ${theme.space[4]};

    ${theme.mediaQueries.medium} {
      margin-left: ${theme.space[1]};
      margin-right: ${theme.space[1]};
      width: calc(33% - ${theme.space[4]});
    }
  }
`
